import React from "react";

const FooterCopyright = () => (
  <div className="footer-copyright">
    <div className="container">
      <div className="row">
        {/* <div className="col-md-6 col-xs-12">
          <ul className="social-media">
            {dataSocial
              .filter((v, i) => i < 5)
              .map((item) => (
                <li key={item.id}>
                  <a href={item.link}>
                    <Icofont icon={item.icon} />
                  </a>
                </li>
              ))}
          </ul>
        </div> */}
        <div className="col-md-12 col-xs-12">
          <div className="copy-right text-center">
            © 2023 Rhodium Residencia. A Project by Potohar Builders.
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default FooterCopyright;
